export default {
  'app.network.offline':
    'Anda sedang offline. Beberapa fitur mungkin tidak tersedia.',
  'app.error.chunk.title': 'Gagal memuat halaman',
  'app.error.chunk.description.offline':
    'Koneksi jaringan terputus. Periksa koneksi Anda dan muat ulang halaman.',
  'app.error.chunk.description.online':
    'Gagal memuat sumber daya halaman. Muat ulang dan coba lagi.',
  'app.error.render.title': 'Terjadi kesalahan',
  'app.error.render.description':
    'Maaf, terjadi kesalahan pada halaman ini. Muat ulang halaman atau kembali ke beranda.',
  'app.error.retry': 'Coba Lagi',
  'app.error.reload': 'Muat Ulang Halaman',
  'app.error.home': 'Kembali ke Beranda',
  'app.request.offline':
    'Jaringan tidak tersedia. Periksa koneksi Anda dan coba lagi.',
};
